import service from '@/assets/service'
import MessageService from '@/assets/service/message' //
import {getCookie} from '@/assets/utils/CommonUtil'
import {zjycloud} from '@/assets/js/config'
import Bus from '@/assets/utils/bus'
import {capitalize, isEmptyObject, clone} from '@/assets/utils'
import {mapState} from 'vuex'

export default {
  data () {
    return {
      isUploadCloud: false,
      taskBars: [], // 任务列表里 是 工程文件显示在最前面 还是 数据文件显示在最前面
      taskSubBars: [],
      changeTaskBarOrder: 0,
      localFiles: [], // 正在上传的本地文件
      batchFilesBox: {}, // 为每个批次创建一个容器
      cloudFiles: [], // 云文件
      spaceFiles: [],
      inventoryFiles: [],
      combinationFiles: [],
      filesLen: 0, // 正在执行上传任务的文件总数
      filesLenUploaded: 0, // 上传已经完成的文件总数
      filesUploadedStatusChangeLen: 0, // 上传完成 和 上传第二种状态 的总数
      filesLenSpace: 0, // 任务列表中 空间文件 数量
      filesLenInventory: 0, // 任务列表中 清单数据 数量
      filesLenCombination: 0, // 任务列表中 组价数据 数量
      refreshUploadTask: 0
    }
  },
  computed: {
    ...mapState({
      uploadTaskShow: state => state.upload.uploadTaskShow
    }),
    // 当前页面
    nowPage () {
      let page = ''
      const path = this.$route.path
      if (/^\/space\/files\/list/.test(path)) {
        // 个人空间
        page = 'personage'
      } else if (/^\/project\/(all|joined)/.test(path)) {
        // 项目库
        page = 'enterprise'
      } else if (/^\/enterprise\/share/.test(path)) {
        // 共享空间
        page = 'share'
      } else {
        // 员工数据库、个人数据库
        let reg = /^\/space\/database\/([^/?&]+)(\/|$|\?)/
        if (/^\/database/.test(path)) {
          // 电子档案室
          reg = /^\/database\/basis\/([^/?&]+)(\/|$|\?)/
        }
        const matchArr = reg.exec(path)
        if (matchArr && matchArr.length > 1) {
          page = matchArr[1]
        }
        // iframe 员工数据-清单-组件   电子档案室-清单-组件
        if (/^\/iframe/.test(path)) {
          // const windowName = this.$route.params.windowName
          // if (windowName) {
          //   page = decodeURIComponent(path).substring(0, decodeURIComponent(path).lastIndexOf(`/${windowName}`)).match(/.*\/(.*)\/.*$/)[1]
          // } else {
          //   page = decodeURIComponent(path).match(/.*\/(.*)\/.*$/)[1]
          // }
          page = decodeURIComponent(path).match(/.*\/(.*)\/.*$/)[1]
        }
      }
      return page
    },
    // 上传文件位置 (空间)工程文件 (数据管理)数据文件
    uploadFilePosition () {
      let position = ''
      switch (this.nowPage) {
        case 'share': // 共享空间 R2 已去掉共享空间了
        case 'enterprise': // 项目库
        case 'personage': // 个人空间
          position = 'space'
          break
        default:
          position = this.nowPage
      }
      return position
    },
    // 数据管理 空间类型定义
    // spaceType () {
    // let type = ''
    // switch (+this.userInStore.userType) {
    //   case 1:
    //     type = 'share'
    //     break
    //   case 2:
    //     type = 'self'
    //     break
    //   case 3:
    //     type = 'staff'
    //     break
    //   default:
    // }
    // return type
    // },
    logTitle () {
      let title = ''
      if (this.nowPage === 'inventory') {
        title = '清单数据管理-'
      }
      if (this.nowPage === 'combination') {
        title = '组价数据管理-'
      }
      return title
    }
  },
  watch: {
    localFiles: {
      handler (val, oldVal) {
        if (val.length > oldVal.length) {
          // 认为新加一批文件
          let timeId = new Date().getTime()
          this.batchFilesBox[timeId] = val.filter((item) => {
            let isNewItem = true
            oldVal.forEach((oldItem) => {
              if (oldItem.id === item.id) {
                isNewItem = false
              }
            })
            if (isNewItem) {
              item.timeId = timeId
            }
            return isNewItem
          })
          console.log(this.batchFilesBox)
        }
      },
      deep: true
    }
  },
  methods: {
    // 1 获取 某个文件的 上传结果
    getUploadResult ({newFile, time, cloudFile, callbackParams}) {
      // console.log(newFile)
      // console.log('上传文件位置是: ' + newFile.position) // space、inventory、combination
      const uuid = newFile.uuid
      // 用于文件成功回调参数处理
      let file = clone(newFile)
      // 获取上传的文件信息
      let thisFile
      if (callbackParams) {
        file = {callbackParams}
      } else {
        this[uuid] = newFile.data.filePath
        thisFile = JSON.parse(JSON.stringify(newFile))
      }
      time = time || 1
      let apiName = 'uploadResult'
      switch (newFile.position) {
        case 'inventory':
        case 'combination':
          apiName = 'uploadResultBigData'
          break
        default:
      }
      setTimeout(() => {
        service.upload[apiName]([uuid]).then((res) => {
          // console.log("uploadResult====>",res)
          if (+res.code === 200 && res.data) {
            for (const key in res.data) {
              let val = res.data[key] // 1: 上传中; 2: 成功; 3: 失败
              if (+val === 1) {
                // 若当前任务 上传中 则 设置轮询获取 这个任务状态的 时间间隔为上一次时间 + 1 （优化点 防止异常任务 过多请求）
                time = time + 1 >= 5 ? 1 : time + 1
                this.getUploadResult({newFile, time, cloudFile, callbackParams})
                return
              } else { // 上传完成
                if (thisFile && ['enterprise', 'personage', 'share'].includes(thisFile.msg.spaceTo)) {
                  // 检查其他是否已完成
                  let complete = true
                  const filesInfo = []
                  const additional = {
                    spaceTo: '',
                    directory: null,
                    drag: null
                  }
                  this.batchFilesBox[thisFile.timeId].map((item, index) => {
                    if (item.id === thisFile.id) {
                      // 记录埋点信息
                      if (!item.fileId && item.data.workspaceId) {
                        item.status = +val === 2 ? 1 : 0
                        // item.fileId = thisFile.uuid
                        item.path = item.data.filePath
                        item.workspaceId = item.data.workspaceId
                        // item.spaceTo = item.msg.spaceTo
                        additional.spaceTo = item.msg.spaceTo
                        additional.directory = item.msg.directory
                        additional.drag = item.msg.drag
                      }
                      // 标记已完成
                      item.msg.end = true
                    }
                    if (!item.abort && !item.msg.end) {
                      complete = false
                    }
                    filesInfo.push({
                      // fileId: item.fileId,
                      status: item.status,
                      suffix: item.name.substring(item.name.lastIndexOf('.') + 1),
                      path: item.path,
                      size: item.size,
                      workspaceId: item.workspaceId
                      // spaceTo: item.spaceTo,
                      // directory: this.directory,
                      // drag: this.parameter.drag
                    })
                  })
                  complete && this.combinationLogParams(filesInfo, additional)
                }
                if (thisFile && thisFile.msg.spaceTo === 'enterprise') { // 是项目空间
                  // 检查其他是否已完成
                  let complete = true
                  // 是否存在成功上传文件
                  let hasSuccessFile = false
                  // 上传完成的文件名称
                  let successFileNames = []
                  this.batchFilesBox[thisFile.timeId].map((item, index) => {
                    if (item.id === thisFile.id) {
                      // 标记已完成
                      item.msg.end = true
                      // 标记成功或失败
                      if (+val === 2) {
                        item.msg.result = true
                      } else {
                        item.msg.result = false
                      }
                    }
                    if (!item.abort && !item.msg.end) {
                      complete = false
                    }
                    if (!item.abort && item.msg.result) {
                      hasSuccessFile = true
                      successFileNames.push(item.name)
                    }
                  })
                  // 如果都完成并且存在上传成功的文件，发送通知信息
                  if (complete && hasSuccessFile) {
                    // 上传成功，消息通知
                    if (+thisFile.msg.type === 6) { // 上传单文件类型
                      let messageParams = {
                        projectName: thisFile.msg.prjName,
                        tip: '上传了1个新文件:' + thisFile.name,
                        type: thisFile.msg.type,
                        url: zjycloud + '/#/project/joined/list'
                      }

                      let messageQuery = {
                        token: getCookie('ZJYTOKEN'),
                        projectId: thisFile.msg.prjId,
                        workspaceId: getCookie('projectWorkspaceIdValue')
                      }
                      MessageService.postMessageUpload(messageParams, messageQuery).then((res) => {

                      })
                    } else if (+thisFile.msg.type === 7) { // 上传多个文件类型
                      let messageParams = {
                        projectName: thisFile.msg.prjName,
                        tip: `上传了${successFileNames.length}个新文件:"${successFileNames.join(',')}`,
                        type: successFileNames.length > 1 ? 7 : 6,
                        url: zjycloud + '/#/project/joined/list'
                      }
                      let messageQuery = {
                        token: getCookie('ZJYTOKEN'),
                        projectId: thisFile.msg.prjId,
                        workspaceId: getCookie('projectWorkspaceIdValue')
                      }
                      MessageService.postMessageUpload(messageParams, messageQuery).then((res) => {

                      })
                    } else if (+thisFile.msg.type === 8) { // 上传文件夹
                      let messageParams = {
                        projectName: thisFile.msg.prjName,
                        tip: `上传了1个新文件夹: ${thisFile.name.split('/')[0]}`,
                        type: thisFile.msg.type,
                        url: zjycloud + '/#/project/joined/list'
                      }
                      let messageQuery = {
                        token: getCookie('ZJYTOKEN'),
                        projectId: thisFile.msg.prjId,
                        workspaceId: getCookie('projectWorkspaceIdValue')
                      }
                      MessageService.postMessageUpload(messageParams, messageQuery).then((res) => {

                      })
                    }
                  }
                }
              }
              let succeed = false
              if (+val === 2) {
                succeed = true
                Bus.$emit('SpaceFileListReload', this[uuid])
                try {
                  console.log(file)
                  // 上传成功，执行回调
                  if (!isEmptyObject(file.callbackParams) && file.callbackParams.fnName && this[file.callbackParams.fnName]) {
                    this[file.callbackParams.fnName](file.callbackParams)
                  }
                } catch (e) {
                  console.log(e)
                }
              }
              this.setUploadFileStatus({
                item: {uuid: key},
                uploadEnd: true,
                succeed,
                cloudFile
              })
            }
          }
        })
      }, 1000 * time)
    },
    // 2. 更新 上传文件状态
    setUploadFileStatus ({item, cloudFile, progress, silence, abort, uuid, succeed, uploadEnd, clear}) {
      const setStatus = (config, matchKey) => {
        matchKey = matchKey || 'id' // 以哪个字段作为 修改数据依据 默认以id
        if (cloudFile) {
          // 修改 云文件状态
          this.cloudFiles.forEach((current, idx) => {
            if (item) {
              if (current[matchKey] === item[matchKey]) {
                this.$set(this.cloudFiles, idx, Object.assign(this.cloudFiles[idx], config))
              }
            } else {
              // 修改所有
              this.$set(this.cloudFiles, idx, Object.assign(this.cloudFiles[idx], config))
            }
          })
        } else {
          // 修改本地文件状态
          this.localFiles.forEach((current, idx) => {
            if (item) {
              if (current[matchKey] === item[matchKey]) {
                this.$set(this.localFiles, idx, Object.assign(this.localFiles[idx], config))
              }
            } else {
              // 修改所有
              this.$set(this.localFiles, idx, Object.assign(this.localFiles[idx], config))
            }
          })
        }
      }
      const config = {}
      let matchKey = 'id'
      // 设置上传进度
      if (progress) {
        config.progress = progress
      }
      // 设置当前文件上传状态为 中断
      if (abort) {
        config.abort = abort
      }
      // 设置静默上传 (已关闭任务列表，这些任务不会显示在任务列表中，但任在上传)
      if (silence) {
        config.silence = silence
      }
      // 设置uuid
      if (uuid) {
        config.uuid = uuid
      }
      // 设置 上传是否成功
      if (succeed) {
        config.succeed = succeed
        matchKey = 'uuid'
      }
      // 设置 上传是否完成
      if (uploadEnd) {
        config.uploadEnd = uploadEnd
        matchKey = 'uuid'
      }
      // console.log(config)
      // console.log(matchKey)
      setStatus(config, matchKey)
      if (clear) {
        this.cloudFiles = []
        this.localFiles = []
      }
      this.computedTaskList()
    },
    // 3. 开始上传云文件
    startUploadCloudFile (params, callbackParams) {
      this.taskBarScrollTop()
      service[this.nowPage].uploadCloudFile(params).then((res) => {
        if (+res.code === 200) {
          const list = res.data || []
          list.forEach((file) => {
            this.setUploadFileStatus({
              item: {id: file.path},
              uuid: file.uuid,
              cloudFile: true
            })
            file.position = this.uploadFilePosition
            this.getUploadResult({newFile: file, cloudFile: true, callbackParams})
          })
        }
      })
      Bus.$emit('closeUploadCloudFile')
    },
    // 4. 计算任务列表展示
    computedTaskList () {
      let filesLen = 0
      let filesLenUploaded = 0
      let filesUploadedStatusChangeLen = 0
      const obj = {
        filesLenSpace: 0,
        filesLenInventory: 0,
        filesLenCombination: 0
      }
      const computedLength = (item, key) => {
        filesLen++
        obj['filesLen' + capitalize(key)]++
        if (item.uploadEnd) {
          filesLenUploaded++
          filesUploadedStatusChangeLen++
        } else {
          if (+item.progress === 100) {
            filesUploadedStatusChangeLen++
          }
        }
      }
      const computed = (key) => {
        const list = []
        let orderArr = ['cloud', 'local']
        if (this.isUploadCloud) {
          orderArr = ['local', 'cloud']
        }
        orderArr.forEach((nowOrder) => {
          this[nowOrder + 'Files'].forEach((item) => {
            if (item.position === key && !item.abort && !item.silence) {
              list.unshift(item)
              computedLength(item, key)
            }
          })
        })
        /*
          this.localFiles.forEach((item) => {
            if (item.position === key && !item.abort && !item.silence) {
              list.unshift(item)
              computedLength(item, key)
            }
          })
          if (key !== 'space') {
            this.cloudFiles.forEach((item) => {
              if (item.position === key && !item.abort && !item.silence) {
                list.unshift(item)
                computedLength(item, key)
              }
            })
          }

         */
        this[key + 'Files'] = list
      }
      const arr = ['space', 'inventory', 'combination']
      arr.forEach((key) => {
        computed(key)
      })
      this.filesLen = filesLen // 正在上传文件总数
      this.filesLenUploaded = filesLenUploaded // 已上传文件总数
      this.filesUploadedStatusChangeLen = filesUploadedStatusChangeLen // 上传完成 和 上传第二种状态 的总数
      this.filesLenSpace = obj.filesLenSpace
      this.filesLenInventory = obj.filesLenInventory
      this.filesLenCombination = obj.filesLenCombination
      this.refreshUploadTask++
    },
    // 5. 上传任务列表 滚动条滚动到最顶部
    taskBarScrollTop () {
      try {
        this.setUploadTaskStatus(true)
        const fileUploadBody = document.getElementById('fileUploadBody')
        if (fileUploadBody) {
          fileUploadBody.scrollTo(0, 0)
        }
        if (this.uploadFilePosition === 'space') {
          this.taskBars = ['space', 'data']
        } else {
          this.taskBars = ['data', 'space']
          if (this.uploadFilePosition === 'inventory') {
            this.taskSubBars = ['inventory', 'combination']
          } else {
            this.taskSubBars = ['combination', 'inventory']
          }
        }
        this.changeTaskBarOrder++
      } catch (error) {
      }

    },
    // 埋点数组组装
    async combinationLogParams (filesInfo, additional = {}) {
      try {
        if (!Array.isArray(filesInfo) || !filesInfo.length) {
          return
        }
        let files = []
        let length = 0
        let $status = []
        for (let i = 0; i < filesInfo.length; i++) {
          const { path, workspaceId, suffix, status, size } = filesInfo[i]
          // 上传成功，查询文件ID
          if (status === 1) {
            // 获取文件ID
            await this.getFileId({path: decodeURIComponent(path), workspaceId}).then(fileId => {
              files.push({fileId, suffix, length: size, status})
              length += size
              $status.push(status)
            })
          } else {
            // 上传失败，直接记录失败文件信息
            files.push({suffix, length: size, status})
            $status.push(status)
          }
        }
        // status: 全部成功 1， 部分成功部分失败 2， 全部失败 0
        Object.assign(additional, {
          length,
          status: $status.includes(1) ? ($status.includes(0) ? 2 : 1) : 0
        })
        this.sendUploadLog(files, additional)
      } catch (e) {
        console.log(e.message)
      }
    },
    // 埋点
    sendUploadLog (files = [], additional) {
      try {
        if ((!Array.isArray(files) || !files.length) || (typeof additional !== 'object' || isEmptyObject(additional))) {
          return
        }
        const { spaceTo, directory, drag, length = 0, status } = additional
        let fnCode = null
        switch (spaceTo) {
          case 'enterprise': // 项目库
            fnCode = drag ? 100112029 : directory ? 100112028 : 100112027
            break
          case 'personage': // 个人空间
            fnCode = drag ? 100113052 : directory ? 100113006 : 100113004
            break
          case 'share': // 共享空间
            fnCode = drag ? 100114019 : directory ? 100114004 : 100114003
            break
          default:
        }
        fnCode && this.sentLog(fnCode, {count: files.length, files, length, status})
      } catch (e) {
        console.log(e.message())
      }
    },
    // 获取文件ID
    getFileId (query) {
      return new Promise((resolve, reject) => {
        service.space.getFileMeta(query).then(res => {
          if (res.code === 200 && res.data && !isEmptyObject(res.data)) {
            resolve(res.data.fileId)
          } else {
            reject(new Error('Failed to get file ID'))
          }
        }).catch(e => {
          reject(e.message)
        })
      })
    }
  }
}
